var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-card" }, [
    _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [_vm._v(" Feedback ")]),
      _c(
        "a",
        {
          staticClass: "close-modal",
          attrs: { "aria-label": "close" },
          on: {
            click: function ($event) {
              return _vm.closeModal()
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _c("section", { staticClass: "modal-card-body" }, [
      _c("p", [
        _vm._v(
          " Would you recommend the Trade Discovery Platform to your friends or colleagues? "
        ),
      ]),
      _c(
        "div",
        { staticClass: "numbers-row" },
        _vm._l(11, function (n, index) {
          return _c(
            "div",
            {
              key: n,
              staticClass: "number-circle",
              class: {
                "number-circle--selected": _vm.selectedNumber === index,
              },
              on: {
                click: function ($event) {
                  _vm.selectedNumber = index
                },
              },
            },
            [_vm._v(" " + _vm._s(index) + " ")]
          )
        }),
        0
      ),
      _vm._m(0),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.comments,
            expression: "comments",
          },
        ],
        staticClass: "textarea",
        attrs: {
          name: "",
          id: "",
          cols: "30",
          rows: "4",
          placeholder: "Comments",
        },
        domProps: { value: _vm.comments },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.comments = $event.target.value
          },
        },
      }),
      _c("div", { staticClass: "button-row flexbox-row-end" }, [
        _c(
          "button",
          {
            staticClass: "button button-secondary button-outline",
            on: {
              click: function ($event) {
                return _vm.closeModal()
              },
            },
          },
          [_vm._v(" Cancel ")]
        ),
        _c(
          "button",
          {
            staticClass: "button button-primary",
            attrs: { disabled: _vm.selectedNumber < 0 || _vm.loading },
            on: {
              click: function ($event) {
                return _vm.submitFeedback()
              },
            },
          },
          [
            _vm._v(" Submit Feedback "),
            _vm.loading ? _c("div", { staticClass: "labs-loader" }) : _vm._e(),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "numbers-label-row" }, [
      _c("div", [_vm._v(" Not Likely ")]),
      _c("div", [_vm._v(" Most Likely ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }